export default __webpack_public_path__ + "static/media/GLA.19aed26d.svg";